export default "__VITE_ASSET__UcjtNqij__"